import { Link } from "react-router-dom";
import Card from "../components/Card";

const features = [
  {
    title: "Edge-first",
    detail: "Serverless APIs on Cloudflare Pages Functions with sub-500ms targets.",
  },
  {
    title: "Secure by default",
    detail: "JWT auth, bcrypt hashing, and RBAC for Admin/Manager/Employee roles.",
  },
  {
    title: "AI-powered insights",
    detail: "Summaries via OpenAI or HuggingFace with cached results in D1 (SQLite).",
  },
];

function Landing() {
  return (
    <div className="space-y-8">
      <section className="grid md:grid-cols-2 gap-8 items-center">
        <div className="space-y-4">
          <p className="text-sm font-semibold text-brand-muted uppercase tracking-wide">
            PD Evaluation System
          </p>
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900">
            Lightweight performance reviews for small teams.
          </h1>
          <p className="text-slate-600">
            Run individual and team evaluations, capture feedback, and generate AI summaries that
            help managers act fast.
          </p>
          <div className="flex gap-3">
            <Link
              to="/dashboard"
              className="px-4 py-2 rounded-md bg-brand-primary text-white font-semibold shadow-sm hover:bg-brand-muted"
            >
              Go to dashboard
            </Link>
            <Link
              to="/evaluations/new"
              className="px-4 py-2 rounded-md border border-slate-300 text-slate-700 font-semibold hover:bg-slate-100"
            >
              Start an evaluation
            </Link>
          </div>
          <p className="text-xs text-slate-500">
            Serverless + Edge-first · Cloudflare D1 · Tailwind + React · Token-based auth
          </p>
        </div>
        <Card
          title="Quick health overview"
          subtitle="Example insight widgets"
          actions={<span className="text-xs text-slate-500">Demo data</span>}
        >
          <div className="grid grid-cols-2 gap-3">
            <div className="p-3 rounded-lg bg-emerald-50 border border-emerald-100">
              <p className="text-xs text-emerald-800">Active cycles</p>
              <p className="text-2xl font-semibold text-emerald-900">3</p>
            </div>
            <div className="p-3 rounded-lg bg-sky-50 border border-sky-100">
              <p className="text-xs text-sky-800">Pending reviews</p>
              <p className="text-2xl font-semibold text-sky-900">12</p>
            </div>
            <div className="p-3 rounded-lg bg-amber-50 border border-amber-100">
              <p className="text-xs text-amber-800">Reminders needed</p>
              <p className="text-2xl font-semibold text-amber-900">5</p>
            </div>
            <div className="p-3 rounded-lg bg-purple-50 border border-purple-100">
              <p className="text-xs text-purple-800">AI summaries cached</p>
              <p className="text-2xl font-semibold text-purple-900">18</p>
            </div>
          </div>
        </Card>
      </section>

      <section className="grid md:grid-cols-3 gap-4">
        {features.map((feature) => (
          <Card key={feature.title} title={feature.title}>
            {feature.detail}
          </Card>
        ))}
      </section>
    </div>
  );
}

export default Landing;
